<div class="container">
  <div class="breadcrumb flat">
    <a [routerLink]="['/pos']"> Home</a>
    <a href="" class="active">Manage Tender</a>
  </div>
</div>
<div class="content bg-light">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="card card-outline-secondary">
          <div class="card-header ">
            <h4 class="mb-0 blue-t d-inline">Tender Manage</h4>
            <div class="float-right d-inline">
              <button class="damke_siteBtn" type="button" id="NewTransaction"
                [routerLink]="['/pos/tender/new']" matTooltip="New Sale Transaction"> New Tender </button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="text-right">
                <!-- <button class="btn damke_siteBtn py-1" color="primary" id="btnExportBatch" (click)="readAndExportToExcelData()" >Export to Excel</button> -->
              </div>
            </div>
          </div>
   
  
        <div class="card-body shadow right-img">
            <ngx-datatable #table class='bootstrap no-detail-row'  [footerHeight]="50"
       [rowHeight]="'auto'"[columnMode]="'force'" [scrollbarH]="true" [limit]="10" [rows]="rows" >
       <ngx-datatable-column name="Action">
         <ng-template let-row="row" ngx-datatable-cell-template>
           <a class=" edit" [routerLink]="['/pos/tender/view',{id : row.Id,posSubscriptionId: row.PosSubscriptionId}]" data-toggle="tooltip"
             data-placement="top" title="View">
             <img src="./assets/ViewDetails.svg">
           </a>
           <a class="edit px-2"
           [routerLink]="['/pos/tender/new',{id : row.Id,posSubscriptionId: row.PosSubscriptionId}]"
           data-toggle="tooltip" data-placement="top" title="Edit">
           <em class="fa-1x mr-2 fas fa-edit"></em>
         </a>
         </ng-template>
       </ngx-datatable-column>


       <ngx-datatable-column name="Tender Name" [width]="205">
                 <ng-template let-row="row" ngx-datatable-cell-template> {{row.TenderName}}
         </ng-template>
       </ngx-datatable-column>
       <ngx-datatable-column name="Tender Type" [width]="205">
         <ng-template let-row="row" ngx-datatable-cell-template>
           
          
            <span  *ngIf="row.TenderType==0">
                Cash
                 </span>
                                     
  <span   *ngIf="row.TenderType==1">
      Credit Card
    </span>
    <span  *ngIf="row.TenderType==2" >
        Debit Card
      </span>
      <span   *ngIf="row.TenderType==3" >
          Wallet
          </span>
          <span  *ngIf="row.TenderType==4" >
              Upi
        </span>
        <span  *ngIf="row.TenderType==5" >
            Stored Card
          </span>
          <span  *ngIf="row.TenderType==6" >
              Net Banking
            </span>
            <span  *ngIf="row.TenderType==7" >
                Bharat Qr Code
              </span>
              <span  *ngIf="row.TenderType==8" >
                  PrePaid Card
                </span>
          
     </ng-template>
       </ngx-datatable-column>

      
       <ngx-datatable-column name="Date Time" [width]="205">
         <ng-template let-row="row" ngx-datatable-cell-template>{{row.DateTime | date:'d/M/yy, h:mm a'}}</ng-template>
       </ngx-datatable-column>

     
       

     </ngx-datatable>
   </div>
 </div>  

</div>
</div>
</div>
</div>
